import React from 'react';
import { Link } from 'react-router-dom';
import { API_URL } from '../../../constants/ApplicationUrl';
import { SUPPORTING_DOCUMENTS } from '../../../constants';
import { ROLES } from '../../../../src/constants/Roles';
import { storage } from '../../../dependencies/store/storage';


const columns = ({
    clickOnAction,
    pageNo,
    size
}) => {
  const userRole = storage.getUserRole();


    return [
        {
            text: 'S.No.',
            formatter: (cell, row, rowIndex) => {
                return (pageNo * size) + (rowIndex + 1);
            }
        }, {
            dataField: 'certificateNumber',
            text: 'Certificate No',
            sort : true
        }, {
            dataField: 'incorporationNumber',
            text: 'Registration No',
            sort : true

        }, {
            dataField: 'incorporationDate',
            text: 'Registration Date',
            sort : true

        }, {
            dataField: 'applicationDate',
            text: 'Application Date',
            sort : true
        }, {
            dataField: 'nameOfEntity',
            text: 'Name Of Entity',
            sort : true
        }, 
        
     {
                dataField: 'action',
                text: 'Action',
                hidden: userRole !== ROLES.SUPER_ADMIN && userRole !== ROLES.ADMIN && userRole !== ROLES.USER,
                formatter: (cell, row) => {
                    const applicationId = row.applicationId
                    if (!row.deepTechApplied) {
    return null;
  }


                    return (
                        <div className="IAS-Actions-list">
                            <ul>
    
                                <li>
                                    <Link to={`/application/startup/${applicationId}`}>
                                        View
                                    </Link>
                                </li>
                                {
                                    userRole !== ROLES.USER ?
                                        <div>
                                            <li><a href="javascript:void(0)" onClick={() => clickOnAction(applicationId)}>View Audit Trail</a></li>
    
                                            
                                        </div>
                                        : ''
                                }
    
    
                            </ul>
    
                        </div>
    
                    )
    
                }
            },
        {
  dataField: 'deepTechApplied',
  text: 'DeepTech Applied Y/N',
  sort: true,
  formatter: (cell) => (cell ? "Yes" : "No")
},
{
            dataField: 'mobileNumber',
            text: 'Mobile No',
            sort : true
        }, {
            dataField: 'recognitionCertificateStatusLabel',
            text: 'COR',
        },
        {
            dataField: 'eightyIACFormStatusLabel',
            text: 'COE',
        }
    ];
}

export default columns;